"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = root;
var _apis = require("./apis");
var _types = require("./types");
var _actions = require("../notification/actions");
var _actions2 = require("./actions");
var _effects = require("redux-saga/effects");
var _schemas = require("../feeds/schemas");
var _selectors = require("./selectors");
var _selectors2 = require("../users/selectors");
var _selectors3 = require("../session/selectors");
var _middlewares = require("../network/middlewares");
var _constants = require("./constants");
var _api = require("../../utils/api");
var _actions3 = require("../feeds/actions");
var _sagas = require("../../utils/sagas");
var _callbacks = _interopRequireDefault(require("../../callbacks"));
var _errorHandler = _interopRequireDefault(require("../../utils/errorHandler"));
var _i18n = _interopRequireDefault(require("../../utils/i18n"));
var _logger = _interopRequireDefault(require("../../utils/logger"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _logger.default('feed_members');
function getFeedMembers(_ref) {
  var {
    _feed
  } = _ref;
  return function* () {
    logger.log('getFeedMembers', {
      _feed
    });
    if (!_feed) return;
    try {
      var {
        data
      } = yield (0, _effects.call)(_apis.$getFeedMembers, _feed);

      /* Get entities currently stored in phone and update data to suit the values returned by the back */
      var currentFeedMembersEntities = yield (0, _effects.select)(_selectors.feedMembersSelectors, _feed);
      if (currentFeedMembersEntities) {
        currentFeedMembersEntities.forEach(userId => {
          if (!data.find(e => {
            var _e$user;
            return (e === null || e === void 0 || (_e$user = e.user) === null || _e$user === void 0 ? void 0 : _e$user.id) === userId;
          })) {
            // If we have an entities that the back didn't returned we update it
            data.push({
              subscriptionStatus: _constants.MEMBERS_STATUS.DELETED,
              user: {
                id: userId
              },
              _feed
            });
          }
        });
      }
      yield* (0, _api.normalizeApiResponse)(data, [_schemas.feedMembers]);
    } catch (e) {
      if ((0, _middlewares.isNetworkError)(e)) return;
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'SUB1',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e);
    }
  }();
}
function updateFeedMembers(_ref2) {
  var {
    _feed,
    _deletedUsers = [],
    _addedUsers = [],
    isNewFeed
  } = _ref2;
  return function* () {
    // Forced to use for...of because yield is unavailable in a foreach callback
    if (_deletedUsers.length > 0) {
      for (var _deletedUser of _deletedUsers) {
        yield (0, _effects.put)((0, _actions2.kickMemberFromFeed)(_feed, _deletedUser));
      }
    }
    if (_addedUsers.length > 0) {
      yield (0, _effects.put)((0, _actions2.inviteMemberIntoFeed)(_feed, _addedUsers));
    }
    _callbacks.default.get('onFeedMembersUpdate')(_feed, isNewFeed);
  }();
}
function inviteMemberIntoFeed(_ref3) {
  var {
    _feed,
    _users
  } = _ref3;
  return function* () {
    try {
      yield (0, _effects.call)(_apis.$postFeedMembers, _feed, _users);
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('sagas.feed.invitationSent', {
          membersInvited: _users.length
        })
      }));
    } catch (e) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'SUB4',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e);
    }
  }();
}
function kickMemberFromFeed(_ref4) {
  var {
    _feed,
    _user
  } = _ref4;
  return function* () {
    try {
      yield (0, _effects.call)(_apis.$deleteFeedMembers, _feed, _user);
      var user = yield (0, _effects.select)(state => (0, _selectors2.getUserById)(state, _user));
      if (user) {
        var {
          firstname = '',
          lastname = ''
        } = user;
        yield (0, _effects.put)((0, _actions.addNotification)({
          message: _i18n.default.translate('feedList.feedBack.kickMember', {
            firstname,
            lastname
          })
        }));
      }
    } catch (e) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'SUB2',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e);
    }
  }();
}
function* patchFeedMember(_feed, status) {
  try {
    var _me = yield (0, _effects.select)(_selectors3.getUserId);
    yield (0, _effects.call)(_apis.$patchFeedMembers, _feed, _me, status);
  } catch (e) {
    yield (0, _effects.put)((0, _actions.addNotification)({
      message: _i18n.default.translate('default.error'),
      referenceError: 'SUB3',
      error: e
    }));
    yield (0, _effects.call)(_errorHandler.default.captureException, e);
  }
}
function acceptMemberInvitationIntoFeed(_ref5) {
  var {
    _feed
  } = _ref5;
  return function* () {
    yield (0, _effects.call)(patchFeedMember, _feed, _constants.MEMBERS_STATUS.ACCEPTED);
    yield (0, _effects.put)((0, _actions2.removePendingInvitation)(_feed));
  }();
}
function rejectMemberInvitationIntoFeed(_ref6) {
  var {
    _feed
  } = _ref6;
  return function* () {
    yield (0, _effects.call)(patchFeedMember, _feed, _constants.MEMBERS_STATUS.DENIED);
    yield (0, _effects.put)((0, _actions2.removePendingInvitation)(_feed));
  }();
}
function cancelMemberInvitationIntoFeed(_ref7) {
  var {
    _feed
  } = _ref7;
  return function* () {
    yield (0, _effects.call)(patchFeedMember, _feed, _constants.MEMBERS_STATUS.PENDING);
    yield (0, _effects.put)((0, _actions2.addPendingInvitation)(_feed));
  }();
}
function wsPostMember(_ref8) {
  var {
    payload
  } = _ref8;
  return function* (_payload$user) {
    var _me = yield (0, _effects.select)(_selectors3.getUserId);
    if (payload !== null && payload !== void 0 && payload._feed && payload !== null && payload !== void 0 && payload.feed && (payload === null || payload === void 0 || (_payload$user = payload.user) === null || _payload$user === void 0 ? void 0 : _payload$user.id) === _me) {
      var _payload$initiator, _payload$user2;
      var _invitation = yield* (0, _api.normalizeApiResponse)({
        _feed: payload._feed,
        feed: payload.feed,
        _initiator: (_payload$initiator = payload.initiator) === null || _payload$initiator === void 0 ? void 0 : _payload$initiator.id,
        initiator: payload.initiator
      }, _schemas.invitations);
      yield (0, _effects.put)((0, _actions2.addPendingInvitation)(_invitation));
      if ((payload === null || payload === void 0 || (_payload$user2 = payload.user) === null || _payload$user2 === void 0 ? void 0 : _payload$user2.id) === _me && payload !== null && payload !== void 0 && payload._feed && (payload === null || payload === void 0 ? void 0 : payload.subscriptionStatus) !== 0) {
        yield (0, _effects.put)((0, _actions3.requestGetFeed)(payload._feed));
      }
    }
  }();
}
function wsPutMember(_ref9) {
  var {
    payload
  } = _ref9;
  return function* (_payload$user3) {
    var _me = yield (0, _effects.select)(_selectors3.getUserId);
    yield* (0, _api.normalizeApiResponse)(payload, _schemas.feedMembers);
    if ((payload === null || payload === void 0 || (_payload$user3 = payload.user) === null || _payload$user3 === void 0 ? void 0 : _payload$user3.id) === _me && payload !== null && payload !== void 0 && payload._feed) {
      yield (0, _effects.put)((0, _actions3.requestGetFeed)(payload._feed));
    }
  }();
}
function wsDeleteMember(_ref10) {
  var {
    payload
  } = _ref10;
  return function* (_payload$user4) {
    yield (0, _effects.delay)(500); // Delay the reducer update to allow the front to navigate

    // Update the entities of the user receiving the event
    yield* (0, _api.normalizeApiResponse)(_objectSpread(_objectSpread({}, payload), {}, {
      subscriptionStatus: _constants.MEMBERS_STATUS.DELETED
    }), _schemas.feedMembers);

    // Handle user receiving the event that he's kicked from a feed
    var _me = yield (0, _effects.select)(_selectors3.getUserId);
    if ((payload === null || payload === void 0 || (_payload$user4 = payload.user) === null || _payload$user4 === void 0 ? void 0 : _payload$user4.id) === _me) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('feedList.feedBack.deletedGroup')
      }));
      yield (0, _effects.put)((0, _actions3.requestGetFeeds)());
    }
  }();
}
function* root() {
  yield (0, _effects.all)([(0, _sagas.takeLatest)(_types.GET_FEED_MEMBERS, getFeedMembers), (0, _sagas.takeLatest)(_types.UPDATE_FEED_MEMBERS, updateFeedMembers), (0, _sagas.takeLatest)(_types.INVITE_MEMBERS_INTO_FEED, inviteMemberIntoFeed), (0, _sagas.takeLatest)(_types.KICK_MEMBER_FROM_FEED, kickMemberFromFeed), (0, _sagas.takeLatest)(_types.ACCEPT_MEMBER_INVITATION_INTO_FEED, acceptMemberInvitationIntoFeed), (0, _sagas.takeLatest)(_types.REJECT_MEMBER_INVITATION_INTO_FEED, rejectMemberInvitationIntoFeed), (0, _sagas.takeLatest)(_types.CANCEL_MEMBER_INVITATION_INTO_FEED, cancelMemberInvitationIntoFeed), (0, _sagas.takeLatest)(_types.WS_POST_MEMBER, wsPostMember), (0, _sagas.takeLatest)(_types.WS_PUT_MEMBER, wsPutMember), (0, _sagas.takeLatest)(_types.WS_DELETE_MEMBER, wsDeleteMember)]);
}
module.exports = exports.default;